/**
 * Created by dx.yang on 2017/3/20.
 */

import Vue from 'vue';
import commonAlert from './alert';

export default function failCallback(c, e) {
    try {
        let msg = _.get(e, 'Error.Message');
        if (!msg) {
            msg = _.get(e, 'error.message');
        }
        if (!msg) {
            msg = e;
        }

        if(msg) {
            commonAlert.send(msg, 'kecDanger');
        } else {
            commonAlert.send(Vue.$trans(`操作失败`), 'kecDanger');
        }

    } catch(er) {
        //未知错误
        commonAlert.send(Vue.$trans(`未知错误`) + '！code: ' + c);
    }
}
